import { action, createRequestTypes } from '../base';

export const paymentTermActionTypes = {
  CREATE_PAYMENT_TERM: createRequestTypes('CREATE_PAYMENT_TERM'),
  GET_PAYMENT_TERMS: createRequestTypes('GET_PAYMENT_TERMS'),
  UPDATE_PAYMENT_TERM: createRequestTypes('UPDATE_PAYMENT_TERM'),
  DELETE_PAYMENT_TERM: createRequestTypes('DELETE_PAYMENT_TERM'),
};

/**
 *
 */
class PaymentTermActions {
  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  createPaymentTerm = (payload, callback) => action(paymentTermActionTypes.CREATE_PAYMENT_TERM.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param createPaymentTermLoading
   * @return {{type: *}}
   */
   createPaymentTermLoading = (createPaymentTermLoading) => action(paymentTermActionTypes.CREATE_PAYMENT_TERM.LOADING, {
     createPaymentTermLoading,
   })

  /**
   * @param orgId
   * @param page
   * @param limit
   * @param searchKeyword
   * @return {{type: *}}
   */
  getPaymentTerms = (orgId, page, limit, searchKeyword) => action(paymentTermActionTypes.GET_PAYMENT_TERMS.REQUEST, {
    orgId,
    page,
    limit,
    searchKeyword,
  })

  /**
   *
   * @param getPaymentTermsLoading
   * @return {{type: *}}
   */
   getPaymentTermsLoading = (getPaymentTermsLoading) => action(paymentTermActionTypes.GET_PAYMENT_TERMS.LOADING, {
     getPaymentTermsLoading,
   })

  /**
   *
   * @param paymentTerms
   * @return {{type: *}}
   */
  getPaymentTermsSuccess = (paymentTerms) => action(paymentTermActionTypes.GET_PAYMENT_TERMS.SUCCESS, {
    paymentTerms,
  })

  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  updatePaymentTerm = (payload, callback) => action(paymentTermActionTypes.UPDATE_PAYMENT_TERM.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param updatePaymentTermLoading
   * @return {{type: *}}
   */
  updatePaymentTermLoading = (updatePaymentTermLoading) => action(paymentTermActionTypes.UPDATE_PAYMENT_TERM.LOADING, {
    updatePaymentTermLoading,
  })

  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
    deletePaymentTerm = (payload, callback) => action(paymentTermActionTypes.DELETE_PAYMENT_TERM.REQUEST, {
      payload, callback,
    })

  /**
   * @param deletePaymentTermLoading
   * @return {{type: *}}
   */
  deletePaymentTermLoading = (deletePaymentTermLoading) => action(paymentTermActionTypes.DELETE_PAYMENT_TERM.LOADING, {
    deletePaymentTermLoading,
  })
}

export default new PaymentTermActions();
